import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { useLocation } from 'react-router';
import qs from 'query-string';
import {
    signUpRequested,
    clearErrorMessages,
    getPackagePricingRequest,
} from '../actions';
import {
    getSignUpError,
    getSignUpInProgress,
    isUserLoggedIn,
    getPriceLoading,
    getPackagePricing,
} from '../selectors';
import TextInput from '../../../common/TextInput/';
import { Redirect } from 'react-router-dom';
import LoginBannerImage from '../../../icons/user-screen-banner.png';
import BrandLogo from '../../../icons/logo.svg';
import LoadingComponent from '../../../common/LoadingComponent';
import {
    TERMS_AND_CONDITIONS_URL,
    PRIVACY_POLICY_URL,
    ROUTE_DASHBOARD,
} from '../../../navigation/constants';
import './styles.scss';
import { noop } from '../../../common/propTypes';
// import { login } from '../../../api';

function Signup({
    onSignUp,
    errorMessage,
    signUpInProgress,
    isLoggedIn,
    clearErrorState,
    activePackageId,
    activePackageName,
    activePackagePrice,
    activePackageKey,
    fetchPricing,
    pricing,
    priceLoading,
}) {
    // scroll top top
    useEffect(() => {
        window.scrollTo(0, 0);
        fetchPricing();
    }, []);

    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState(null);
    const [validationMessage, setValidationMessage] = useState(null);
    const [tosAccepted, setTOSAccepted] = useState(false);
    const [subscription, setSubscription] = useState(false);
    const location = useLocation();
    const passwordPattern = new RegExp(
        '(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z`\'"<>/?|!@#$%^&\\\\*(){}_+-=~\\[\\]\\d]{8,}',
    );

    let isValid = true;
    let packageError = null;

    const loader = (
        <div className="buttonLoader">
            <LoadingComponent isLoading={signUpInProgress || priceLoading} />
        </div>
    );

    const queryParams = qs.parse(location.search);
    if (queryParams.package && pricing) {
        if (pricing[queryParams.package.toUpperCase()]) {
            activePackageName = pricing[queryParams.package.toUpperCase()].name;
            activePackageId =
                pricing[queryParams.package.toUpperCase()].pricingId;
            activePackagePrice =
                pricing[queryParams.package.toUpperCase()].price;
            activePackageKey = pricing[queryParams.package.toUpperCase()].key;
        } else {
            packageError = 'Selected package does not exist';
        }
    }
    const buttonText = signUpInProgress ? loader : 'Become a Litterati Partner';
    const isInviteLinkAvailable = localStorage.getItem('invite');

    // TODO should be done via persist blacklist
    useEffect(() => {
        clearErrorState();
    }, []);

    const newDate = new Date();
    return (
        <Fragment>
            {isLoggedIn ? (
                <Redirect
                    to={{
                        ...location,
                        pathname: ROUTE_DASHBOARD,
                    }}
                />
            ) : (
                <Fragment>
                    <section className="login-block strip-block userScreens mb-5 h-100">
                        <div
                            className="row mx-0 backgroundImage"
                            style={{
                                backgroundImage: `url(${LoginBannerImage})`,
                            }}
                        >
                            <div className="col-md-6 col-lg-7"></div>
                            <div className="col-md-6 pl-md-0 col-lg-5">
                                <div className="userBox">
                                    <div className="userBoxContent">
                                        <div className="logo mt-3 mb-5">
                                            <img src={BrandLogo} alt="logo" />
                                        </div>
                                        {errorMessage && !signUpInProgress ? (
                                            <p>{errorMessage}</p>
                                        ) : null}
                                        {validationMessage || packageError ? (
                                            <p>
                                                {validationMessage
                                                    ? validationMessage
                                                    : packageError}
                                            </p>
                                        ) : null}
                                        <form
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                if (
                                                    password &&
                                                    passwordPattern.test(
                                                        password,
                                                    ) === false
                                                ) {
                                                    isValid = false;
                                                    setValidationMessage(
                                                        'Password should be a minimum of 8 characters with at least 1 uppercase, 1 lowercase, and 1 digit',
                                                    );
                                                    return;
                                                }
                                                if (
                                                    tosAccepted &&
                                                    isValid &&
                                                    !packageError
                                                ) {
                                                    onSignUp(
                                                        {
                                                            username,
                                                            email,
                                                            password,
                                                            socialPlatform: null,
                                                            token: null,
                                                            fullName: null,
                                                            socialId: null,
                                                            profilePicture: null,
                                                        },
                                                        activePackageName,
                                                        activePackagePrice,
                                                        activePackageKey,
                                                        subscription,
                                                        activePackageId,
                                                    );
                                                    setValidationMessage(null);
                                                } else {
                                                    setValidationMessage(
                                                        'you need to accept the terms & conditions',
                                                    );
                                                }
                                            }}
                                        >
                                            <div className="filter-form">
                                                {isInviteLinkAvailable ? (
                                                    <h2 className="mb-4 userBoxTitle">
                                                        Create Your Account
                                                    </h2>
                                                ) : (
                                                    <h2 className="mb-4 userBoxTitle">
                                                        Create Your <br />{' '}
                                                        Organization’s Account
                                                    </h2>
                                                )}

                                                <span>
                                                    <div className="customInput pt-0">
                                                        <h3 className="titleStyle2">
                                                            Username
                                                        </h3>
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text icon-profile-icon"></span>
                                                            </div>
                                                            <TextInput
                                                                type="text"
                                                                onChange={(
                                                                    event,
                                                                ) =>
                                                                    setUsername(
                                                                        event
                                                                            .target
                                                                            .value,
                                                                    )
                                                                }
                                                                value={username}
                                                                placeholder={
                                                                    'Enter Username'
                                                                }
                                                                pattern="[a-zA-Z0-9]+"
                                                                title="For your username, please only use letters and numbers with no spaces."
                                                                required="required"
                                                                maxLength={32}
                                                                minLength={5}
                                                            />
                                                        </div>
                                                        <small className="hint">
                                                            For your username,
                                                            please only use
                                                            letters and numbers
                                                            with no spaces.
                                                        </small>
                                                    </div>
                                                    <div className="customInput">
                                                        <h3 className="titleStyle2">
                                                            Your Email
                                                        </h3>
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text icon2-mail"></span>
                                                            </div>
                                                            <TextInput
                                                                type="text"
                                                                onChange={(
                                                                    event,
                                                                ) =>
                                                                    setEmail(
                                                                        event
                                                                            .target
                                                                            .value,
                                                                    )
                                                                }
                                                                value={email}
                                                                placeholder={
                                                                    'abc@example.com'
                                                                }
                                                                required="required"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="customInput">
                                                        <h3 className="titleStyle2">
                                                            Password
                                                        </h3>
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text icon2-open"></span>
                                                            </div>
                                                            <TextInput
                                                                type="password"
                                                                onChange={(
                                                                    event,
                                                                ) =>
                                                                    setPassword(
                                                                        event
                                                                            .target
                                                                            .value,
                                                                    )
                                                                }
                                                                value={password}
                                                                placeholder={
                                                                    'Password'
                                                                }
                                                                minLength={8}
                                                                title="Minimum of 8 characters with at least 1 uppercase, 1 lowercase, and 1 digit"
                                                                required="required"
                                                            />
                                                        </div>
                                                        <small className="hint">
                                                            Minimum of 8
                                                            characters with at
                                                            least 1 uppercase, 1
                                                            lowercase, and 1
                                                            digit
                                                        </small>
                                                    </div>
                                                </span>
                                                {/* IF CONDITION ENDS HERER */}

                                                <div className="customInput">
                                                    <div className="custom-checkbox custom-control mb-0">
                                                        <input
                                                            type="checkbox"
                                                            className="custom-control-input"
                                                            id="customCheck1"
                                                            onChange={() => {
                                                                setTOSAccepted(
                                                                    !tosAccepted,
                                                                );
                                                            }}
                                                        />
                                                        <label
                                                            className="custom-control-label"
                                                            htmlFor="customCheck1"
                                                        >
                                                            I have read and
                                                            agree to the{' '}
                                                            <a
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                href={
                                                                    TERMS_AND_CONDITIONS_URL
                                                                }
                                                            >
                                                                Terms and
                                                                Conditions
                                                            </a>{' '}
                                                            &{' '}
                                                            <a
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                href={
                                                                    PRIVACY_POLICY_URL
                                                                }
                                                            >
                                                                Privacy Policy
                                                            </a>
                                                            .
                                                        </label>
                                                    </div>
                                                    <div className="custom-checkbox custom-control mb-0">
                                                        <input
                                                            type="checkbox"
                                                            className="custom-control-input"
                                                            id="subscriptioncheck"
                                                            checked={
                                                                subscription
                                                            }
                                                            onChange={() => {
                                                                setSubscription(
                                                                    !subscription,
                                                                );
                                                            }}
                                                        />
                                                        <label
                                                            className="custom-control-label"
                                                            htmlFor="subscriptioncheck"
                                                        >
                                                            Stay updated with
                                                            latest new features
                                                            from Litterati via
                                                            email.
                                                        </label>
                                                    </div>
                                                </div>

                                                <button
                                                    type="submit"
                                                    className="btn btn-custom btn-block"
                                                    disabled={packageError}
                                                >
                                                    {isInviteLinkAvailable
                                                        ? 'Create Your Account'
                                                        : buttonText}
                                                </button>
                                            </div>
                                        </form>
                                        <div className="alreadyMember text-center">
                                            {isInviteLinkAvailable
                                                ? 'Already have an account? '
                                                : 'Does your organization already have an account? '}
                                            <a href="">Log In</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <footer>
                        <p className="copyrights-signup text-center">
                            &copy; Copyright {newDate.getFullYear()} Litterati
                        </p>
                    </footer>
                </Fragment>
            )}
        </Fragment>
    );
}

Signup.propTypes = {
    // function to be called when form is submitted
    onSignUp: PropTypes.func.isRequired,

    // error message to be shown when something goes wrong with signup request
    errorMessage: PropTypes.string,

    // indicates whether user is logged in or not
    isLoggedIn: PropTypes.bool,

    // whether login has been requested
    signUpInProgress: PropTypes.bool,

    // Defining package name statically
    activePackageName: PropTypes.string,

    // Key associated to a package, required to be sent at the backend
    activePackageKey: PropTypes.string,

    // Defining package price statically
    activePackagePrice: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    activePackageId: PropTypes.string,
    // function to clear error message
    clearErrorState: PropTypes.func.isRequired,

    fetchPricing: PropTypes.func,
    priceLoading: PropTypes.bool,
    pricing: PropTypes.object,
};

Signup.defaultProps = {
    errorMessage: 'null',
    signUpInProgress: false,
    isLoggedIn: false,
    fetchPricing: noop,
};

// Maintaining Store states
const mapStateToProps = (state) => {
    return {
        errorMessage: getSignUpError(state),
        signUpInProgress: getSignUpInProgress(state),
        isLoggedIn: isUserLoggedIn(state),
        pricing: getPackagePricing(state),
        priceLoading: getPriceLoading(state),
    };
};

// Store action dispatchers
const mapDispatchToProps = (dispatch) => {
    return {
        onSignUp: (
            userCreds,
            activePackageName,
            activePackagePrice,
            activePackageKey,
            subscription,
            activePackageId,
        ) =>
            dispatch(
                signUpRequested(
                    userCreds,
                    activePackageName,
                    activePackagePrice,
                    activePackageKey,
                    subscription,
                    activePackageId,
                ),
            ),
        clearErrorState: () => dispatch(clearErrorMessages()),
        fetchPricing: () => dispatch(getPackagePricingRequest()),
    };
};

// Connect redux store with the component
const ConnectedSignup = connect(mapStateToProps, mapDispatchToProps)(Signup);

export default ConnectedSignup;
